<template>
  <div class="container">
    <my-nav-ui :idx="4"></my-nav-ui>
    <div class="bottom">
      <baidu-map
        class="map"
        :zoom="zoom"
        :center="center"
        @ready="handler"
      ></baidu-map>
      <!-- <div class="panel" style></div> -->
    </div>
    <div class="map-info" id="mapInfo">
      <ul>
        <li>{{ mapInfo.name }}（{{ mapInfo.count }}台）</li>
        <li>设备数：{{ mapInfo.gatewayCount }}</li>
        <li>报警数：{{ mapInfo.alarm }}</li>
        <li>报障数：{{ mapInfo.fault }}</li>
        <li>投诉数：{{ mapInfo.complaint }}</li>
      </ul>
    </div>
    <div class="tip">
      <span @click="goBack">返回</span>
    </div>
  </div>
</template>

<script>
import GLOBAL from '@/api/global_variable'
export default {
  name: 'MapDetail',
  data() {
    return {
      loading: true,
      name: null,
      center: { lng: 0, lat: 0 },
      zoom: 20,
      show: false,
      markerPoint: { lng: 0, lat: 0 },
      mapStyle: { styleJson: [] },
      areaData: [],
      hasName: false,
      mapInfo: {
        name: '',
        count: 0,
        gatewayCount: 0,
        alarm: 0,
        fault: 0,
        complaint: 0,
      },
      districtsId: '',
    }
  },
  mounted() {
    if (!GLOBAL.isLogin()) {
      this.$router.push({ path: '/login' })
    }
    this.initPage()
  },
  methods: {
    goBack() {
      this.$router.back(-1)
    },
    initPage: function () {
      this.ViewData = GLOBAL.viewData
      //this.loadData(this.ViewData)
    },
    loadData: function (map) {
      this.loadMapStyle()
    },
    handler({ BMap, map }) {
      if (!this.$route.query.name) {
        this.center = this.$route.query.name //默认中心点位置 城市名称
        this.name = this.$route.query.name
      }
      //后台获取点位信息
      this.districtsId = this.$route.query.id
      const regionType = sessionStorage.getItem('regionType')
      this.$http({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
          citytype: parseInt(regionType) + 1,
          cityid: this.districtsId,
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/byitem',
      }).then((res) => {
        if (res.data.result.length === 0) {
          GLOBAL.viewData = [
            {
              groupId: 1,
              groupName: '中海信创新产业城',
              longitude: 113.047377,
              latitude: 25.806654,
              totalAlarmCount: 8,
              totalComplaintCount: 1,
              totalFaultCount: 2,
              totalFixingCount: 2,
            },
            {
              groupId: 2,
              groupName: '中海信',
              longitude: 113.048387,
              latitude: 25.816655,
              totalAlarmCount: 37,
              totalComplaintCount: 5,
              totalFaultCount: 2,
              totalFixingCount: 1,
            },
          ]
        } else {
          GLOBAL.viewData = res.data.result

          this.center.lng = GLOBAL.viewData[0].longitude
          this.center.lat = GLOBAL.viewData[0].latitude
        }
        this.initMapPoint(BMap, map)
        this.loadMapStyle(map);
      })
    },
    initMapPoint(BMap, map) {
      var markIcon = null
      var markIcon0 = new BMap.Icon(
        require('../assets/mark_0.png'),
        new BMap.Size(20, 20)
      )
      var markIcon1 = new BMap.Icon(
        require('../assets/mark_1.png'),
        new BMap.Size(20, 20)
      )

      if (GLOBAL.viewData) {
        for (var i = 0; i < GLOBAL.viewData.length; i++) {
          // 数据返回清新县处理方法
          // var ItemRegion = this.$route.query.name
          // if (ItemRegion === '清新县') {
          //   ItemRegion = '清新区'
          // }
          // if (this.name === GLOBAL.viewData[i].ItemRegion) {
          //   this.hasName = true
          // }
          this.areaData.push(GLOBAL.viewData[i])
          if (!this.center.lng || !this.center.lat) {
            this.center.lng = GLOBAL.viewData[i].longitude
            this.center.lat = GLOBAL.viewData[i].latitude
          }
          if (GLOBAL.viewData[i].totalAlarmCount > 0) {
            markIcon = markIcon1
          } else {
            markIcon = markIcon0
          }
          // 设置标注的经纬度
          var point = new BMap.Point(
            GLOBAL.viewData[i].longitude,
            GLOBAL.viewData[i].latitude
          )
          var marker = new BMap.Marker(point, {
            //icon: markIcon,
            //title: GLOBAL.viewData[i].groupName,
          })

          var opts = {
            position: point, // 指定文本标注所在的地理位置
            offset: new BMap.Size(13, -11), // 设置文本偏移
          }
          var label = new BMap.Label(GLOBAL.viewData[i].groupName, opts)
          label.setStyle({
            color: '#121d49',
            fontSize: '12px',
            height: '20px',
            lineHeight: '20px',
            fontFamily: '微软雅黑',
            backgroundColor: '',
            border: '0px',
          })
          // 把标注添加到地图上
          map.addOverlay(marker)
          // 把文本添加到地图
          map.addOverlay(label)
          var that = this
          //鼠标移动到圆点位置 显示浮动窗口
          var data = GLOBAL.viewData
          marker.addEventListener('mouseover', function (evt) {
            if (that.mapInfo.name !== evt.target.z.title) {
              var mapInfo = document.getElementById('mapInfo')
              mapInfo.style.left = evt.clientX - 80 + 'px'
              mapInfo.style.top = evt.clientY - 102 + 'px'
              mapInfo.style.display = 'block'
              var markerData = data
              for (var z = 0; z < markerData.length; z++) {
                if (markerData[z].groupName === evt.target.z.title) {
                  that.mapInfo.count = markerData[z].totalFixingCount
                  that.mapInfo.gatewayCount = markerData[z].totalGatewayCount
                  that.mapInfo.name = markerData[z].groupName
                  that.mapInfo.alarm = markerData[z].totalAlarmCount
                  that.mapInfo.fault = markerData[z].totalFaultCount
                  that.mapInfo.complaint = markerData[z].totalComplaintCount
                  break
                }
              }
            }
          })
          // 鼠标移开远点位置 影藏浮动窗口
          marker.addEventListener('mouseout', function (evt) {
            var mapInfo = document.getElementById('mapInfo')
            that.mapInfo.name = ''
            mapInfo.style.display = 'none'
          })

          //点击项目名字 跳转至项目详情
          label.addEventListener('click', function (evt) {
            for (var i = 0; i < that.areaData.length; i++) {
              if (that.areaData[i].groupName === evt.target.content) {
                that.goProject(that.areaData[i])
              }
            }
          })
        }
      } else {
        this.center.lng = this.$route.query.lng
        this.center.lat = this.$route.query.lat
      }
      this.zoom = 14
      // 启用滚轮放大缩小
      map.enableScrollWheelZoom()

      setTimeout(function () {
        // 隐藏百度版权信息
        var objs = document.getElementsByClassName('BMap_cpyCtrl')
        for (var i = 0; i < objs.length; i++) {
          objs[i].style.display = 'none'
        }
        objs = document.getElementsByClassName('anchorBL')
        for (i = 0; i < objs.length; i++) {
          objs[i].style.display = 'none'
        }
      }, 2000)
    },
    goProject: function (item) {
      GLOBAL.defaultProj[0] = item.groupId
      GLOBAL.defaultProj[1] = item.longitude
      GLOBAL.defaultProj[2] = item.latitude
      this.$router.push({
        path: '/info',
        query: {
          key: item.groupId,
          lng: item.longitude,
          lat: item.latitude,
        },
      })
    },
    infoWindowClose() {
      this.show = false
    },
    infoWindowOpen() {
      this.show = true
    },
    loadMapStyle: function (map) {
      this.axios
        .get('/static/custom_map_config.json')
        .then((res) => {
          this.mapStyle.styleJson = res.data
          //map.setMapStyle(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>
<style lang="css" rel="stylesheet/scss"  scoped>
.container {
  width: 100%;
  height: calc(100% - 40px);
  background: #0b133f;
}
.bottom {
  height: calc(100% - 106px);
  height: -webkit-calc(100% - 106px);
  height: -moz-calc(100% - 106px);
  width: 100%;
  display: inline-flex;
}
.map {
  width: 100%;
  height: 100%;
}
#zoomer {
  display: none;
}
.map span {
  display: none;
}
.map .anchorBL {
  display: none !important;
  position: absolute;
}
.BMap_cpyCtrl {
  display: none;
}
.panel {
  background: url('../../static/panel3.1.png') no-repeat;
  background-size: 200px 150px;
  position: absolute;
  bottom: 40px;
  right: 40px;
  width: 300px;
  height: 150px;
}

.tip {
  width: 100px;
  height: 32px;
  position: absolute;
  bottom: 100px;
  right: 100px;
  z-index: 41;
  display: none;
}

.tip > span {
  height: 30px;
  line-height: 30px;
  width: 100%;
  background: #121d49;
  border-radius: 6px;
  border: 1px solid #43bcff;
  font-size: 12px;
  color: #a7c6d6;
  cursor: pointer;
}
.map-info {
  width: 160px;
  height: 100px;
  position: absolute;
  z-index: 42;
  background: #121d49;
  border-radius: 6px;
  border: 1px solid #43bcff;
  top: 50%;
  left: 50%;
  display: none;
}

.map-info > ul {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.map-info > ul > li {
  list-style: none;
  width: 90%;
  height: 19px;
  line-height: 19px;
  font-size: 12px;
  text-align: left;
  color: #a7c6d6;
  margin: 0 auto;
}
.map-info > ul > li:first-child {
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/MapDetail.vue